<template>
	<b-modal
		:hide-footer="true"
		:title="$t('Cadastrar Conta Bancária')"
		centered
		id="create-conta-banco"
	>
		<div class="row" v-if="loading">
			<load mode="table" />
		</div>
		<div v-else>
			<div class="row">
				<form-input label="Banco" grid="6" v-model="banco" />
				<form-input label="Agência" grid="6" v-model="agencia" />
				<form-input label="Número Conta" grid="6" v-model="numero" />
				<form-select label="Tipo da Conta" grid="6" v-model="tipo" :itens="tipos" />
			</div>
			<div class="row pt-4 px-2 d-flex justify-content-end">
				<button @click="submit" class="btn btn-success btn-submit">
					<i class="mdi mdi-content-save"></i>
					Salvar
				</button>
			</div>
		</div>
	</b-modal>
</template>
<script>
export default {
	props: ["item"],
	data() {
		return {
			loading: false,
			banco: "",
			agencia: "",
			numero: "",
			tipo: "",
			tipos: [
				{ id: 1, value: "Corrente" },
				{ id: 2, value: "Poupança" },
			],
		};
	},
	methods: {
		submit() {
			this.loading = true;
			axios
				.post("api/dashboard/usuarios/contabanco", {
					usuario_id: this.item.id,
					banco: this.banco,
					agencia: this.agencia,
					conta_numero: this.numero,
					conta_tipo: this.tipo,
				})
				.then((response) => {
					this.$snack.success({
						button: false,
						text: "Conta bancaria cadastrada com sucesso.",
					});
					this.item.bancos = response.data;
					this.loading = false;
					this.$bvModal.hide("create-conta-banco");
					this.banco = "";
					this.agencia = "";
					this.numero = "";
					this.tipo = "";
				});
		},
	},
};
</script>
